<template>
  <div class="base-textarea-wrapper">
    <label v-if="label" :for="textareaId" class="base-textarea__label">{{ label }}</label>
    <textarea
      :id="textareaId"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :rows="rows"
      class="base-textarea"
      @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    ></textarea>
    <small v-if="hint" class="base-textarea__hint">{{ hint }}</small>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  modelValue: string;
  label?: string;
  placeholder?: string;
  hint?: string;
  disabled?: boolean;
  rows?: number;
}>();

defineEmits<{
  'update:modelValue': [value: string];
  focus: [event: FocusEvent];
  blur: [event: FocusEvent];
}>();

const textareaId = computed(() => `textarea-${Math.random().toString(36).substr(2, 9)}`);
</script>

<style scoped>
.base-textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.base-textarea__label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.base-textarea {
  width: 100%;
  min-height: 60px;
  padding: 0.875rem var(--spacing-md);
  border: 2px solid var(--color-border-light);
  border-radius: var(--radius-md);
  font-size: var(--font-size-lg);
  font-family: var(--font-family);
  transition: all var(--transition-base);
  box-sizing: border-box;
  resize: vertical;
}

.base-textarea:focus {
  outline: none;
  border-color: var(--color-border-focus);
  box-shadow: var(--shadow-focus);
}

.base-textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: var(--color-bg-tertiary);
}

.base-textarea__hint {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}
</style>

